/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * クレカ3DS決済状態取得APIレスポンス, 決済が完了した場合のみ情報が設定されます。
 * 処理中の決済が存在するがまだ完了していない場合はnullが設定されます。
 * @export
 * @interface StripePaymentStatusResponseModel
 */
export interface StripePaymentStatusResponseModel {
    /**
     * StripeのPaymentIntentID
     * @type {string}
     * @memberof StripePaymentStatusResponseModel
     */
    paymentIntentId?: string;
    /**
     * 購入したコイン数
     * @type {number}
     * @memberof StripePaymentStatusResponseModel
     */
    amount?: number;
    /**
     * 購入ボーナス数(ボーナスポイントの場合はポイント数, チケットの場合はチケット数)
     * @type {number}
     * @memberof StripePaymentStatusResponseModel
     */
    bonus?: number;
}

/**
 * Check if a given object implements the StripePaymentStatusResponseModel interface.
 */
export function instanceOfStripePaymentStatusResponseModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StripePaymentStatusResponseModelFromJSON(json: any): StripePaymentStatusResponseModel {
    return StripePaymentStatusResponseModelFromJSONTyped(json, false);
}

export function StripePaymentStatusResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripePaymentStatusResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentIntentId': !exists(json, 'paymentIntentId') ? undefined : json['paymentIntentId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'bonus': !exists(json, 'bonus') ? undefined : json['bonus'],
    };
}

export function StripePaymentStatusResponseModelToJSON(value?: StripePaymentStatusResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentIntentId': value.paymentIntentId,
        'amount': value.amount,
        'bonus': value.bonus,
    };
}

